module.exports = __webpack_public_path__ + "static/media/main-profile.d767941b.png";